import _extends from "@babel/runtime-corejs2/helpers/extends";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import Loader from '../../../../../../components/Loader';
import NavMenuDivider from '../../../NavMenuDivider';
import Product from '../Product';
import { getProducts } from '../../../../../../config/apps';
import { IntegratedExperience } from './IntegratedExperience';
import { fetchProductsActivationInfo } from '../../../../../../api/fetch-products-activation-info';
import { getLink } from '../../links';
import { PRODUCT_STATUS, generateInitialProductsStatus, generateStatusForAllProducts } from '../../productsStatus';

var ContentContainer = function ContentContainer(_ref) {
  var currentProduct = _ref.currentProduct,
      environment = _ref.environment,
      features = _ref.features,
      inverted = _ref.inverted,
      onLinkClick = _ref.onLinkClick,
      onReloadHandler = _ref.onReloadHandler,
      swicusOrgId = _ref.swicusOrgId,
      onShowFeedbackModal = _ref.onShowFeedbackModal;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasIntegratedExperience = _useState4[0],
      setIntegratedExperience = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      productsStatusCallSuccess = _useState6[0],
      setProductsStatusCallSuccess = _useState6[1];

  var _useState7 = useState(generateInitialProductsStatus(currentProduct)),
      _useState8 = _slicedToArray(_useState7, 2),
      productsStatus = _useState8[0],
      setProductsStatus = _useState8[1];

  var hasPingdomConvergence = features.pingdomConvergence;
  useEffect(function () {
    if (swicusOrgId) {
      getProductsActivationInfo();
    } else {
      setLoading(false);
    }
  }, [swicusOrgId]);

  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, {
      active: true,
      inline: "centered"
    });
  }

  return /*#__PURE__*/React.createElement(ContentComponent, {
    currentProduct: currentProduct,
    environment: environment,
    features: features,
    hasIntegratedExperience: hasIntegratedExperience,
    inverted: inverted,
    onLinkClick: onLinkClick,
    onReloadHandler: onReloadHandler,
    products: getProducts(hasIntegratedExperience, hasPingdomConvergence),
    productsStatus: productsStatus,
    swicusOrgId: swicusOrgId,
    productsStatusCallSuccess: productsStatusCallSuccess,
    onShowFeedbackModal: onShowFeedbackModal
  });

  function getProductsActivationInfo() {
    return _getProductsActivationInfo.apply(this, arguments);
  }

  function _getProductsActivationInfo() {
    _getProductsActivationInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var info;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchProductsActivationInfo(environment, swicusOrgId);

            case 3:
              info = _context.sent;
              setNewProductsStatus(info.products);
              setIntegratedExperience(info.hasCombinedNavigation);
              setProductsStatusCallSuccess(true);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              // eslint-disable-next-line no-console
              console.error(_context.t0);
              setNewProductsStatus(generateStatusForAllProducts(PRODUCT_STATUS.CAN_SWITCH));

            case 13:
              setLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));
    return _getProductsActivationInfo.apply(this, arguments);
  }

  function setNewProductsStatus(productsStatus) {
    productsStatus[currentProduct] = PRODUCT_STATUS.CURRENT_PRODUCT;
    setProductsStatus(productsStatus);
  }
};

export var ContentComponent = function ContentComponent(_ref2) {
  var currentProduct = _ref2.currentProduct,
      environment = _ref2.environment,
      features = _ref2.features,
      hasIntegratedExperience = _ref2.hasIntegratedExperience,
      inverted = _ref2.inverted,
      _onLinkClick = _ref2.onLinkClick,
      onReloadHandler = _ref2.onReloadHandler,
      products = _ref2.products,
      productsStatus = _ref2.productsStatus,
      swicusOrgId = _ref2.swicusOrgId,
      productsStatusCallSuccess = _ref2.productsStatusCallSuccess,
      onShowFeedbackModal = _ref2.onShowFeedbackModal;
  var isIntegratedExperienceFeedbackEnabled = features && features.integratedExperienceFeedback;
  return /*#__PURE__*/React.createElement(React.Fragment, null, products.map(function (product) {
    var productStatus = productsStatus[product.id];
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: product.id
    }, /*#__PURE__*/React.createElement(Product, _extends({}, product, {
      url: getLink(currentProduct, environment, products, product.id, productsStatus, swicusOrgId),
      features: features,
      inverted: inverted,
      productStatus: productStatus,
      swicusOrgId: swicusOrgId,
      onLinkClick: function onLinkClick() {
        return _onLinkClick(product.id, productStatus);
      }
    })), /*#__PURE__*/React.createElement(NavMenuDivider, null));
  }), isIntegratedExperienceVisible() && /*#__PURE__*/React.createElement(IntegratedExperience, {
    environment: environment,
    hasIntegratedExperience: hasIntegratedExperience,
    onReloadHandler: onReloadHandler,
    currentProduct: currentProduct,
    onShowFeedbackModal: isIntegratedExperienceFeedbackEnabled ? onShowFeedbackModal : undefined,
    swicusOrgId: swicusOrgId
  }));

  function isIntegratedExperienceVisible() {
    return productsStatusCallSuccess && currentProduct !== 'papertrail';
  }
};
export var Content = ContentContainer;